import * as React from 'react';
import PropTypes from 'prop-types';

const GoogleAd = ({
  id,
  client = 'ca-pub-3279400529363034',
  slot,
  format = 'auto', // Format option = 'auto' or 'fluid' (in-article)
  layout,
  customStyle = { display: 'block', textAlign: 'center' },
  enabled = true
}) => (
  enabled && (
    <div key={id}>
      {layout && layout.trim() != '' ? (
        <ins
          id={id}
          className="adsbygoogle"
          data-ad-client={client}
          data-ad-slot={slot} //"2200633996" or other ID for In-article ad (Also match your site and work well with articles and content pages)
          data-ad-format={format}
          data-ad-layout={layout}
          style={customStyle}
        />
      ) : (
        <ins
          id={id}
          className="adsbygoogle"
          data-ad-client={client}
          data-ad-slot={slot} //"9433178566" or other ID for display ads (A great all-rounder that’s designed to work well anywhere)
          data-ad-format={format}
          style={customStyle}
          data-full-width-responsive="true"
        />
      )}
    </div>
  )
);

GoogleAd.prototype = {
  id: PropTypes.string.isRequired,
  client: PropTypes.string,
  slot: PropTypes.string.isRequired,
  format: PropTypes.string,
  layout: PropTypes.string,
  customStyle: PropTypes.object
};

export default GoogleAd;
